// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"95":"6de7c341","225":"36407a9c","353":"8973a055","673":"db4dbc39"}[chunkId] + ".js";
};